// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-tabs {
  display: flex;
  height: var(--v-tabs-height);
}
:where(.vuetify-styles) .v-tabs--density-default {
  --v-tabs-height: 48px;
}
:where(.vuetify-styles) .v-tabs--density-default.v-tabs--stacked {
  --v-tabs-height: 72px;
}

:where(.vuetify-styles) .v-tabs--density-comfortable {
  --v-tabs-height: 44px;
}
:where(.vuetify-styles) .v-tabs--density-comfortable.v-tabs--stacked {
  --v-tabs-height: 68px;
}

:where(.vuetify-styles) .v-tabs--density-compact {
  --v-tabs-height: 36px;
}
:where(.vuetify-styles) .v-tabs--density-compact.v-tabs--stacked {
  --v-tabs-height: 60px;
}

:where(.vuetify-styles) .v-tabs.v-slide-group--vertical {
  height: auto;
  flex: none;
  --v-tabs-height: 48px;
}

:where(.vuetify-styles) .v-tabs--align-tabs-title:not(.v-slide-group--has-affixes) .v-tab:first-child {
  margin-inline-start: 42px;
}

:where(.vuetify-styles) .v-tabs--fixed-tabs .v-slide-group__content > *:last-child,
:where(.vuetify-styles) .v-tabs--align-tabs-center .v-slide-group__content > *:last-child {
  margin-inline-end: auto;
}
:where(.vuetify-styles) .v-tabs--fixed-tabs .v-slide-group__content > *:first-child,
:where(.vuetify-styles) .v-tabs--align-tabs-center .v-slide-group__content > *:first-child {
  margin-inline-start: auto;
}

:where(.vuetify-styles) .v-tabs--grow {
  flex-grow: 1;
}
:where(.vuetify-styles) .v-tabs--grow .v-tab {
  flex: 1 0 auto;
  max-width: none;
}

:where(.vuetify-styles) .v-tabs--align-tabs-end .v-tab:first-child {
  margin-inline-start: auto;
}
:where(.vuetify-styles) .v-tabs--align-tabs-end .v-tab:last-child {
  margin-inline-end: 0;
}

:where(.vuetify-styles) .v-tabs--inset {
  --v-tabs-inset-radius: 4px;
  --v-tabs-inset-padding: 4px;
  --v-tabs-slider-background: rgba(var(--v-theme-on-surface), .2);
  background: rgba(var(--v-theme-on-surface), 0.06);
  box-shadow: inset 0 0 0 2px rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: calc(var(--v-tabs-inset-radius) + var(--v-tabs-inset-padding));
}
:where(.vuetify-styles) .v-tabs--inset .v-tab {
  margin: var(--v-tabs-inset-padding);
  transition-property: box-shadow, transform, opacity, background, color;
}
:where(.vuetify-styles) .v-tabs--inset .v-tab.v-tab.v-btn {
  border-radius: var(--v-tabs-inset-radius);
}
:where(.vuetify-styles) .v-tabs--inset .v-tab:focus-visible {
  outline: 2px solid rgb(var(--v-border-color));
  outline-offset: 2px;
}
:where(.vuetify-styles) .v-tabs--inset .v-tab:focus-visible:after {
  opacity: 0;
}
:where(.vuetify-styles) .v-tabs--inset:not(.v-tabs--fixed-tabs, .v-tabs--grow) {
  max-width: max-content;
}
:where(.vuetify-styles) .v-tabs--inset.v-tabs--fixed-tabs .v-slide-group__content {
  padding-inline: var(--v-tabs-inset-padding);
}
:where(.vuetify-styles) .v-tabs--inset .v-tab__slider {
  background: var(--v-tabs-slider-background);
  inset: 0;
  border-radius: var(--v-tabs-inset-radius);
  z-index: -1;
  width: auto;
}
:where(.vuetify-styles) .v-tabs--inset.v-tabs--horizontal {
  height: calc(var(--v-tabs-height) + var(--v-tabs-inset-padding) * 2);
  --v-tabs-inset-tab-radius: calc(var(--v-tabs-outer-radius) - var(--v-tabs-inset-padding) + 4px);
}
:where(.vuetify-styles) .v-tabs--inset.v-tabs--horizontal .v-tab__slider {
  height: auto;
}
:where(.vuetify-styles) .v-tabs--inset .v-btn__overlay {
  display: none;
}
:where(.vuetify-styles) .v-tabs--inset.v-tabs--vertical .v-tab {
  grid-template-columns: max-content 1fr max-content;
}
:where(.vuetify-styles) .v-tabs--inset.v-tabs--vertical .v-tab > .v-btn__content {
  justify-content: start;
}
:where(.vuetify-styles) .v-tabs--inset.v-tabs--vertical .v-tab .v-tab__slider {
  width: auto;
}

@media (max-width: 1279.98px) {
  :where(.vuetify-styles) .v-tabs.v-slide-group--is-overflowing.v-slide-group--horizontal:not(.v-slide-group--has-affixes) .v-tab:first-child {
    margin-inline-start: 52px;
  }
  :where(.vuetify-styles) .v-tabs.v-slide-group--is-overflowing.v-slide-group--horizontal:not(.v-slide-group--has-affixes) .v-tab:last-child {
    margin-inline-end: 52px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTabs/VTabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+DAA+D;EAC/D,iDAAiD;EACjD,gFAAgF;EAChF,6EAA6E;AAC/E;AACA;EACE,mCAAmC;EACnC,sEAAsE;AACxE;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,QAAQ;EACR,yCAAyC;EACzC,WAAW;EACX,WAAW;AACb;AACA;EACE,oEAAoE;EACpE,+FAA+F;AACjG;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kDAAkD;AACpD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".v-tabs {\n  display: flex;\n  height: var(--v-tabs-height);\n}\n.v-tabs--density-default {\n  --v-tabs-height: 48px;\n}\n.v-tabs--density-default.v-tabs--stacked {\n  --v-tabs-height: 72px;\n}\n\n.v-tabs--density-comfortable {\n  --v-tabs-height: 44px;\n}\n.v-tabs--density-comfortable.v-tabs--stacked {\n  --v-tabs-height: 68px;\n}\n\n.v-tabs--density-compact {\n  --v-tabs-height: 36px;\n}\n.v-tabs--density-compact.v-tabs--stacked {\n  --v-tabs-height: 60px;\n}\n\n.v-tabs.v-slide-group--vertical {\n  height: auto;\n  flex: none;\n  --v-tabs-height: 48px;\n}\n\n.v-tabs--align-tabs-title:not(.v-slide-group--has-affixes) .v-tab:first-child {\n  margin-inline-start: 42px;\n}\n\n.v-tabs--fixed-tabs .v-slide-group__content > *:last-child,\n.v-tabs--align-tabs-center .v-slide-group__content > *:last-child {\n  margin-inline-end: auto;\n}\n.v-tabs--fixed-tabs .v-slide-group__content > *:first-child,\n.v-tabs--align-tabs-center .v-slide-group__content > *:first-child {\n  margin-inline-start: auto;\n}\n\n.v-tabs--grow {\n  flex-grow: 1;\n}\n.v-tabs--grow .v-tab {\n  flex: 1 0 auto;\n  max-width: none;\n}\n\n.v-tabs--align-tabs-end .v-tab:first-child {\n  margin-inline-start: auto;\n}\n.v-tabs--align-tabs-end .v-tab:last-child {\n  margin-inline-end: 0;\n}\n\n.v-tabs--inset {\n  --v-tabs-inset-radius: 4px;\n  --v-tabs-inset-padding: 4px;\n  --v-tabs-slider-background: rgba(var(--v-theme-on-surface), .2);\n  background: rgba(var(--v-theme-on-surface), 0.06);\n  box-shadow: inset 0 0 0 2px rgba(var(--v-border-color), var(--v-border-opacity));\n  border-radius: calc(var(--v-tabs-inset-radius) + var(--v-tabs-inset-padding));\n}\n.v-tabs--inset .v-tab {\n  margin: var(--v-tabs-inset-padding);\n  transition-property: box-shadow, transform, opacity, background, color;\n}\n.v-tabs--inset .v-tab.v-tab.v-btn {\n  border-radius: var(--v-tabs-inset-radius);\n}\n.v-tabs--inset .v-tab:focus-visible {\n  outline: 2px solid rgb(var(--v-border-color));\n  outline-offset: 2px;\n}\n.v-tabs--inset .v-tab:focus-visible:after {\n  opacity: 0;\n}\n.v-tabs--inset:not(.v-tabs--fixed-tabs, .v-tabs--grow) {\n  max-width: max-content;\n}\n.v-tabs--inset.v-tabs--fixed-tabs .v-slide-group__content {\n  padding-inline: var(--v-tabs-inset-padding);\n}\n.v-tabs--inset .v-tab__slider {\n  background: var(--v-tabs-slider-background);\n  inset: 0;\n  border-radius: var(--v-tabs-inset-radius);\n  z-index: -1;\n  width: auto;\n}\n.v-tabs--inset.v-tabs--horizontal {\n  height: calc(var(--v-tabs-height) + var(--v-tabs-inset-padding) * 2);\n  --v-tabs-inset-tab-radius: calc(var(--v-tabs-outer-radius) - var(--v-tabs-inset-padding) + 4px);\n}\n.v-tabs--inset.v-tabs--horizontal .v-tab__slider {\n  height: auto;\n}\n.v-tabs--inset .v-btn__overlay {\n  display: none;\n}\n.v-tabs--inset.v-tabs--vertical .v-tab {\n  grid-template-columns: max-content 1fr max-content;\n}\n.v-tabs--inset.v-tabs--vertical .v-tab > .v-btn__content {\n  justify-content: start;\n}\n.v-tabs--inset.v-tabs--vertical .v-tab .v-tab__slider {\n  width: auto;\n}\n\n@media (max-width: 1279.98px) {\n  .v-tabs.v-slide-group--is-overflowing.v-slide-group--horizontal:not(.v-slide-group--has-affixes) .v-tab:first-child {\n    margin-inline-start: 52px;\n  }\n  .v-tabs.v-slide-group--is-overflowing.v-slide-group--horizontal:not(.v-slide-group--has-affixes) .v-tab:last-child {\n    margin-inline-end: 52px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
